// // src/utils/PrivateRoute.js
// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children, roles = [] }) => {
//     const access_token = useSelector((state) => state.auth.access_token);

//     const role = "admin"
//     if (!role || !access_token) return <Navigate to="/" />;

//     // if (roles.length && !roles.includes(user.role)) {
//     //     return <Navigate to="/403" />;
//     // }

//     return children;
// };

// export default PrivateRoute;

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, roles }) => {
    const { userdetails, access_token } = useSelector((state) => state.auth);
    const location = useLocation();

    const isAuthenticated = access_token || localStorage.getItem("authToken");

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }
    if (!roles) return children;

    const userRole = userdetails?.role?.toUpperCase(); 
    if (userRole === "ADMIN") return children;

    if (roles.includes(userRole)) {
        return children;
    }

    return <Navigate to="/dashboard" replace />;
};

export default PrivateRoute;